<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  data() {
    return {
      local: this.value
    };
  },
  watch: {
    local(v) {
      this.$emit('input', v);
    }
  }
};
</script>

<template>
  <b-card-footer>
    <b-row align-v="baseline">
      <b-col>
        <div class="dataTables_paginate paging_simple_numbers pagination-sm">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination v-model="local" :total-rows="total" :per-page="perPage"></b-pagination>
          </ul>
        </div>
        <div class="float-end">
          <strong>{{ total }}</strong> enregistrements
        </div>
      </b-col>
    </b-row>
  </b-card-footer>
</template>